/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Add/Content/AppointmentType/Error"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 width="100%"
 maxWidth={400}
 type="secondary"
 size="small"
 disabled={true}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Error loading appointment types"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 marginLeft="auto"
 marginRight={dtSpaceXs}
>
{childProps => (
<Tysiav2ChevronDown
{...childProps}
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 width={dtSpaceLs}
 height={dtSpaceLs}
 fill2={dtColorsNeutral500}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}